var toggle = document.querySelector('#results-toggle');

if (toggle) {
  toggle.addEventListener('click', () => {
    let target = document.querySelector('#' + toggle.getAttribute('data-target'));
    if (target.getAttribute('aria-hidden') === 'true') {
      target.setAttribute('aria-hidden', false);
      toggle.setAttribute('aria-expanded', true);
    } else {
      target.setAttribute('aria-hidden', true);
      toggle.setAttribute('aria-expanded', false);
    }
  });
}